var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWine = function SvgIconWine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.54 1.967a1 1 0 0 1 .96-.717h9a1 1 0 0 1 .959.717l2.448 8.282a3.26 3.26 0 0 1-.162 2.258A8.5 8.5 0 0 1 13 17.446v3.304h2.75a1 1 0 1 1 0 2h-7.5a1 1 0 1 1 0-2H11v-3.304a8.5 8.5 0 0 1-6.746-4.94 3.26 3.26 0 0 1-.161-2.257v-.004zm8.985 12.5a6.5 6.5 0 0 1-3.433 1.037 1 1 0 0 0-.184 0 6.5 6.5 0 0 1-5.831-3.822l-.001-.002a1.26 1.26 0 0 1-.064-.87l.001-.003.204-.69c.924-.387 2.746-.764 5.336.528 2.808 1.403 5.024 1.234 6.454.786a1.3 1.3 0 0 1-.083.25h-.001a6.5 6.5 0 0 1-2.398 2.785m2.064-5.004c-.98.353-2.732.598-5.142-.607v-.001c-2.275-1.134-4.163-1.24-5.562-.999L8.247 3.25h7.506z",
    clipRule: "evenodd"
  })));
};
export default SvgIconWine;